export default "__VITE_ASSET__DzHemC_B__"